export function normalize(string: string, unicodeNormalizationForm = 'NFD'): string {
  return string?.normalize(unicodeNormalizationForm).replace(/\p{Diacritic}/gu, "") || "";
}
